import { FC } from 'react'
import { usePointMultipliers } from '../hooks/usePointMultipliers'
import { Box, VStack, Text } from '@chakra-ui/react'
import PointMultiplierCard from '../../common/components/PointMultiplierCard'
import CalloutBox from '../../../components/CalloutBox'
import RaffleCardListSkeleton from '../../dApp/components/Skeletons/RaffleCardListSkeleton'


const RunningPointMultipliersView: FC = () => {
  const pointMultiplierRes = usePointMultipliers(true)

  return (
    <VStack w='full' mt='10' spacing='1rem'>
      <CalloutBox
        emoji='📈'
        infoText='Point multipliers allow you to earn more points if you tag certain communities or if you raffle an NFT of a certain collection.'
      ></CalloutBox>
      {pointMultiplierRes.data &&
        pointMultiplierRes.data?.map((pm) => {
          return (
            <PointMultiplierCard
              pointMultiplier={pm}
              refetch={pointMultiplierRes.refetch}
              isAdminView={false}
            />
          )
        })}
      {pointMultiplierRes.isLoading && (
        <Box w='100%'>
          <RaffleCardListSkeleton />
        </Box>
      )}
      {!pointMultiplierRes.isLoading &&
        pointMultiplierRes.data?.length == 0 && (
          <Text mt='2rem'>No running point multipliers</Text>
        )}
    </VStack>
  )
}

export default RunningPointMultipliersView